import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Spinner,
  Image,
  Card,
  Button,
} from "react-bootstrap";
import { fetchResultsClient, fetchPersonality } from "../utils/fetchUtils";
import { determinePersonality } from "../utils/personalityUtils";
import Header from "../components/Header";
import ElipsePsikotesResult1 from "../../assets/elipseHome1.png";
import ElipsePsikotesResult2 from "../../assets/elipseHome2.png";
import ElipsePsikotesResult3 from "../../assets/elipseHome3.png";
import CustomToast from "../../shared/CustomToast";
import "../styles/psikotesResult.css";

function PsikotesResult() {
  const { psikotesId, user, resultId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [personality, setPersonality] = useState(null);
  const [personalityKey, setPersonalityKey] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastTitle, setToastTitle] = useState("");
  const [toastBody, setToastBody] = useState("");
  const [toastBgColor, setToastBgColor] = useState("");

  const showToastMessage = useCallback((title, message, bgColor) => {
    setToastTitle(title);
    setToastBody(message);
    setToastBgColor(bgColor);
    setShowToast(true);
  }, []);

  useEffect(() => {
    const loadResults = async () => {
      try {
        const data = await fetchResultsClient(psikotesId, user, resultId);
        if (data) {
          const personalityType =
            data.personality || determinePersonality(data.finalResults);

          setPersonalityKey(personalityType);

          if (personalityType) {
            const personalityData = await fetchPersonality(personalityType);
            setPersonality(personalityData);
          } else {
            setPersonality(null);
          }
        }
      } catch (error) {
        console.error("Error load result data:", error);
        showToastMessage(
          "Error",
          "There was an error for load result data.",
          "danger"
        );
      } finally {
        setLoading(false);
      }
    };

    loadResults();
  }, [psikotesId, user, resultId, showToastMessage]);

  const personalityColors = {
    D: "#fb6e6e",
    I: "#61af83",
    S: "#84cffc",
    C: "#fbe898",
  };

  const personalityColor = personalityColors[personalityKey] || "#000";

  const handleBtnKembali = () => {
    navigate("/home");
  };

  return (
    <Container fluid id="conatiner-psikotes-result">
      <Header />
      <Image src={ElipsePsikotesResult1} className="elipse-psikotes-result1" />
      <Image src={ElipsePsikotesResult2} className="elipse-psikotes-result2" />
      <Image src={ElipsePsikotesResult3} className="elipse-psikotes-result3" />
      <Row className="d-flex justify-content-center align-items-center text-center pt-3">
        {loading ? (
          <Col md={12} className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading</span>
            </Spinner>
          </Col>
        ) : personality && personalityKey ? (
          <Col
            md={12}
            className="d-flex justify-content-center align-items-center text-center"
          >
            <Card className="card-psikotes-result">
              <Card.Body className="d-flex flex-column gap-3">
                <Card.Title className="d-flex flex-column gap-2" >
                  <span>Kepribadian Kamu Adalah </span>
                  <div>
                    <strong style={{ color: personalityColor }}>
                      {personalityKey} ({personality.type})
                    </strong>
                  </div>
                </Card.Title>
                <p>{personality.description}</p>
              </Card.Body>
            </Card>
          </Col>
        ) : (
          <Col md={12} className="text-center">
            <p>No data available.</p>
          </Col>
        )}
      </Row>
      <Row className="text-center mt-5 mb-4">
        <Col>
          <Button className="btn-kembali" onClick={handleBtnKembali}>
            Kembali
          </Button>
        </Col>
      </Row>
      <CustomToast
        showToast={showToast}
        setShowToast={setShowToast}
        title={toastTitle}
        body={toastBody}
        bgColor={toastBgColor}
      />
    </Container>
  );
}

export default PsikotesResult;
